import find from 'lodash/find';

export class PaymentMethodsService {
    constructor($resource, ApiService) {
        'ngInject';

        this.$resource = $resource;
		this.apiService = ApiService;

        this.paymentMethodsListResourceUrl = this.apiService.getResourceUrl('cms/payment-methods');
        this.paymentMethodsListResource = this.$resource(this.paymentMethodsListResourceUrl);
    }

    getPaymentMethods({data}) {
        return this._getPaymentMethodObject(find(data.content, ['name', 'PaymentMethods']).values);
    }

    addPaymentMethod({paymentMethod:payment_method}) {
        const promise = this.paymentMethodsListResource.save({payment_method}).$promise;

        return promise
            .then(details => details)
            .catch(err => {
                throw this.apiService.getErrorMessage(err);
            });
    }

    _getPaymentMethodObject(values) {
		return values.map(value => ({
			id: value.payment_method_id,
            name: value.payment_method
		}));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/payment-methods/payment-methods.service.js